/*
 * Geo Header Controller — Phase 2 configuration contract.
 * One profile per region: phoneDisplay, phoneHref, contactUrl, showroomLabel, showroomUrl.
 * A field set to "TBD" or "VERIFY" is a known placeholder — the controller falls back
 * to the default profile's value for that field until the client supplies a real one.
 */
window.GeoHeaderProfiles = Object.freeze({
  default: {
    phoneDisplay: '800-416-4304',
    phoneHref: 'tel:800-416-4304',
    contactUrl: '/pages/contact-us',
    showroomLabel: 'Showroom',
    showroomUrl: null
  },
  seattle: {
    phoneDisplay: '206-743-0116',
    phoneHref: 'tel:12067430116',
    contactUrl: '/pages/seattle-contact-us',
    showroomLabel: 'Showroom',
    showroomUrl: '/pages/seattle-kent-washington-massage-chair-showroom'
  },
  orlando: {
    phoneDisplay: '407-768-0975',
    phoneHref: 'tel:14077680975',
    contactUrl: '/pages/orlando-contact-us',
    showroomLabel: 'Showroom',
    showroomUrl: '/pages/orlando-florida-massage-chair-showroom'
  },
  sarasota: {
    phoneDisplay: 'VERIFY',
    phoneHref: 'VERIFY',
    contactUrl: '/pages/contact-us',
    showroomLabel: 'Showroom',
    showroomUrl: '/pages/sarasota-florida-massage-chair-showroom'
  },
  // atlanta, columbia, denver, houston, gardena: added 2026-08-21 for the territory expansion
  // request (see GEO_HEADER_UPDATE_LOG.md). No phone/contact/showroom data yet for any of
  // them — all TBD, so they silently fall back to the default profile until the store owner
  // supplies real values, same as Orlando/Sarasota above.
  atlanta: {
    phoneDisplay: '404-984-2025',
    phoneHref: 'tel:4049842025',
    contactUrl: '/pages/atlanta-contact-us',
    showroomLabel: 'Showroom',
    showroomUrl: '/pages/atlanta-georgia-massage-chair-showroom'
  },
  columbia: {
    phoneDisplay: '410-844-0365',
    phoneHref: 'tel:4108440365',
    contactUrl: '/pages/columbia-contact-us',
    showroomLabel: 'Showroom',
    showroomUrl: '/pages/columbia-maryland-massage-chair-showroom'
  },
  denver: {
    phoneDisplay: '303-395-1223',
    phoneHref: 'tel:3033951223',
    contactUrl: '/pages/denver-contact-us',
    showroomLabel: 'Showroom',
    showroomUrl: '/pages/denver-colorado-massage-chair-showroom'
  },
  houston: {
    phoneDisplay: '713-489-6565',
    phoneHref: 'tel:7134896565',
    contactUrl: '/pages/houston-contact-us',
    showroomLabel: 'Showroom',
    showroomUrl: '/pages/houston-texas-massage-chair-showroom'
  },
  gardena: {
    phoneDisplay: '213-452-1564',
    phoneHref: 'tel:2134521564',
    contactUrl: '/pages/gardena-contact-us',
    showroomLabel: 'Showroom',
    showroomUrl: '/pages/los-angeles-gardena-massage-chair-showroom'
  }
});

// Match priority (order doesn't affect matching logic, just cache/test-override validation —
// see matchTerritory() in geo-header-controller.js for actual match order).
window.GeoHeaderRegionPriority = Object.freeze([
  'seattle', 'orlando', 'sarasota', 'atlanta', 'columbia', 'denver', 'houston', 'gardena', 'default'
]);
